const API_URLS = [
  'https://ve.dolarapi.com/v1/dolares/oficial',
  'https://pydolarve.org/api/v2/dollar?page=bcv'
];
const CACHE_MS = 30 * 60 * 1000;
const FALLBACK_RATE = 820.1018;
const PRICE_SELECTORS = [
  '#js-product-price',
  '.product-price [data-js-product-price]',
  '.product-price .current',
  '.product-price .compare',
  '.product-collection__price span',
  '[data-js-product-price] span',
  '.price .current',
  '.price .compare',
  '.sticky_atc_price',
  'span.money',
  '.js-total-price',
  '.unit_price'
].join(',');

let exchangeRate = FALLBACK_RATE;
let converting = false;
let convertTimer = null;

function storageGet(key) {
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    return null;
  }
}

function storageSet(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {}
}

function parseRate(value) {
  const rate = parseFloat(value);
  return isFinite(rate) && rate > 0 ? rate : null;
}

function readCachedRate() {
  const lastUpdate = parseInt(storageGet('rateUpdated'), 10);
  if (!lastUpdate || Date.now() - lastUpdate > CACHE_MS) return null;
  return parseRate(storageGet('exchangeRate'));
}

async function fetchJson(url) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 8000);
  try {
    const response = await fetch(url, { cache: 'no-store', signal: controller.signal });
    if (!response.ok) throw new Error('HTTP ' + response.status);
    return await response.json();
  } finally {
    clearTimeout(timer);
  }
}

function rateFromPayload(data) {
  if (!data || typeof data !== 'object') return null;
  return parseRate(
    data.promedio ||
    data.venta ||
    data.compra ||
    (data.monitors && data.monitors.usd && data.monitors.usd.price) ||
    (data.sources && data.sources.oficial && data.sources.oficial.price)
  );
}

async function fetchExchangeRate() {
  const cached = readCachedRate();
  if (cached) {
    exchangeRate = cached;
    return exchangeRate;
  }

  for (const url of API_URLS) {
    try {
      const data = await fetchJson(url);
      const rate = rateFromPayload(data);
      if (!rate) continue;

      exchangeRate = rate;
      storageSet('exchangeRate', String(rate));
      storageSet('rateUpdated', String(Date.now()));
      return exchangeRate;
    } catch (error) {
      console.error('Error fetching exchange rate:', url, error);
    }
  }

  exchangeRate = parseRate(storageGet('exchangeRate')) || FALLBACK_RATE;
  return exchangeRate;
}

function parseUsdPrice(text) {
  if (!text) return null;
  const match = String(text).replace(/\s/g, '').match(/\$([\d,]+(?:\.\d+)?)/);
  if (!match) return null;
  return parseRate(match[1].replace(/,/g, ''));
}

function isUsdOnlyText(element) {
  const text = String(element.textContent || '').replace(/\s/g, '');
  return /^\$[\d,]+(?:\.\d+)?$/.test(text);
}

function formatPriceHtml(usdPrice) {
  const convertedPrice = (usdPrice * exchangeRate).toFixed(2);
  const formattedPrice = new Intl.NumberFormat('es-VE').format(convertedPrice);
  return '<span class="hs-ves-bs">Bs. ' + formattedPrice + '</span><span class="hs-ves-usd" style="color:#8a8a8a">$' + usdPrice.toFixed(2) + ' USD</span>';
}

function convertPrices() {
  if (!exchangeRate || converting) return;

  converting = true;
  observer.disconnect();

  try {
    document.querySelectorAll(PRICE_SELECTORS).forEach(element => {
      if (element.classList.contains('hs-ves-bs') || element.classList.contains('hs-ves-usd')) return;

      if (element.querySelector('span, div, small') && !isUsdOnlyText(element)) {
        if (!element.hasAttribute('data-original-price')) return;
      }

      let usdPrice = null;
      if (isUsdOnlyText(element)) {
        usdPrice = parseUsdPrice(element.textContent);
      } else {
        usdPrice = parseRate(element.getAttribute('data-original-price'));
        if (usdPrice === null) usdPrice = parseUsdPrice(element.textContent);
      }

      if (usdPrice === null) return;

      const applied = element.getAttribute('data-applied-rate');
      if (applied && Number(applied) === exchangeRate && element.hasAttribute('data-converted')) {
        return;
      }

      element.innerHTML = formatPriceHtml(usdPrice);
      element.setAttribute('data-original-price', String(usdPrice));
      element.setAttribute('data-applied-rate', String(exchangeRate));
      element.setAttribute('data-converted', 'true');
    });
  } finally {
    converting = false;
    startObserver();
  }
}

function scheduleConvert() {
  if (converting) return;
  clearTimeout(convertTimer);
  convertTimer = setTimeout(convertPrices, 200);
}

const observer = new MutationObserver(mutations => {
  if (converting) return;

  const hasNewPrice = mutations.some(mutation => {
    const target = mutation.target;
    if (target && target.nodeType === 1 && target.matches && target.matches('#js-product-price, [data-js-product-price], .product-price, .sticky_atc_price')) {
      return true;
    }
    if (mutation.type !== 'childList') return false;
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches && node.matches(PRICE_SELECTORS) && !node.hasAttribute('data-converted')) return true;
      if (node.querySelector && node.querySelector('#js-product-price, .product-collection__price span:not([data-converted]), [data-js-product-price] span:not([data-converted]), span.money:not([data-converted])')) return true;
    }
    return false;
  });

  if (hasNewPrice) scheduleConvert();
});

function startObserver() {
  if (!document.body) return;
  observer.observe(document.body, { childList: true, subtree: true });
}

function injectPriceStyles() {
  if (document.getElementById('hs-ves-price-styles')) return;
  const style = document.createElement('style');
  style.id = 'hs-ves-price-styles';
  style.textContent = '.hs-ves-usd{font-size:12px;font-weight:400;color:#8a8a8a!important;white-space:nowrap;line-height:1.2}.product-item .frm-price-color,.product-item .product-collection__price,.product-item .product-collection__price .price{display:flex!important;flex-direction:column;align-items:flex-start;width:100%;gap:2px}.product-item .hs-ves-bs{font-weight:600;white-space:nowrap}.product-item .hs-ves-usd,.product-item .price .hs-ves-usd,.product-item .product-collection__price .price .hs-ves-usd,.product-item .product-collection__content .frm-price-color .product-collection__price .price .hs-ves-usd,.product-item .price.price--sale span.hs-ves-usd{display:block;margin-left:0;color:#8a8a8a!important;font-size:12px!important;font-weight:400!important}.details-info .product-price .hs-ves-usd,.details-info #js-product-price .hs-ves-usd,.sticky_atc_price .hs-ves-usd{display:block;margin-top:6px;font-size:14px;color:#8a8a8a!important}';
  document.head.appendChild(style);
}

async function initConverter() {
  injectPriceStyles();
  storageSet('selectedCurrency', 'VES');
  convertPrices();
  await fetchExchangeRate();
  convertPrices();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initConverter);
} else {
  initConverter();
}
